export const ar = {
  nav: {
    home: 'الرئيسية',
    treatments: 'العلاجات',
    results: 'النتائج',
    gallery: 'المعرض',
    compare: 'المقارنة',
    blog: 'المدونة',
    locations: 'المواقع',
    contact: 'اتصل بنا',
    bookConsultation: 'استشارة مجانية',
    hairAnalysis: 'تحليل الشعر بالذكاء الاصطناعي',
  },
  hairTransplant: {
    title: 'زراعة الشعر بتقنية FUE',
    subtitle: 'استخراج الوحدات البصيلية المتقدم يهدف إلى نتائج طبيعية ودائمة نسبياً. النتائج تختلف من شخص لآخر.',
    bookConsultation: 'احجز استشارة مجانية',
    viewResults: 'شاهد النتائج',
    benefits: 'لماذا تختار زراعة الشعر FUE؟',
    process: 'إجراء FUE خطوة بخطوة',
    pricing: 'باقات الأسعار الشفافة',
    stats: 'نتائجنا',
  },
  stemcellTherapy: {
    title: 'العلاج بالخلايا الجذعية',
    subtitle: 'محتوى معلوماتي حول أبحاث الخلايا الجذعية في استعادة الشعر. يعتمد التوفر على التقييم الطبي واللوائح المحلية.',
    benefits: 'فوائد العلاج بالخلايا الجذعية',
    howItWorks: 'كيف يعمل',
    pricing: 'باقات العلاج بالخلايا الجذعية',
    idealFor: 'من يجب أن يفكر في العلاج بالخلايا الجذعية؟',
  },
  prp: {
    title: 'علاج الشعر بالبلازما',
    subtitle: 'علاج البلازما الغنية بالصفائح الدموية لتحفيز نمو الشعر الطبيعي',
    whatIs: 'ما هو علاج PRP للشعر؟',
    benefits: 'فوائد علاج PRP',
    procedure: 'إجراء PRP',
    packages: 'باقات علاج PRP',
    results: 'متى تتوقع النتائج',
    idealFor: 'من يجب أن يفكر في PRP؟',
  },
  hero: {
    title: 'زراعة الشعر المتقدمة في أوروبا',
    subtitle: 'نجمع بين الخبرة الجراحية التركية ومعايير الرعاية الأوروبية. نقدم إجراءات FUE وDHI. النتائج الفردية تختلف حسب الملاءمة والتقنية والرعاية اللاحقة.',
    bookConsultation: 'احجز استشارة مجانية',
    whatsapp: 'واتساب',
  },
  services: {
    title: 'خدماتنا المتميزة لاستعادة الشعر',
    subtitle: 'تقنيات متقدمة تجمع بين الخبرة التركية ومعايير الجودة الأوروبية',
  },
  results: {
    title: 'أمثلة من المرضى والجدول الزمني المتوقع',
    subtitle: 'أمثلة توضيحية من مرضى سابقين. النتائج الفردية تختلف حسب المنطقة المانحة ونمط تساقط الشعر والصحة والتقنية والرعاية اللاحقة.',
  },
  locations: {
    title: 'مواقع مريحة في جميع أنحاء أوروبا',
    subtitle: 'رعاية متميزة في منشآت حديثة',
  },
  contact: {
    title: 'ابدأ رحلة استعادة شعرك',
    subtitle: 'احجز استشارتك المجانية اليوم',
    name: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    treatment: 'مهتم بـ',
    message: 'أخبرنا عن مخاوفك بشأن تساقط الشعر',
    send: 'إرسال',
    sending: 'جاري الإرسال...',
  },
  footer: {
    about: 'تجمع عيادات Hair Art بين التميز الطبي التركي ومعايير الجودة الأوروبية، وتقدم خدمات استعادة الشعر المتميزة عبر شريكنا في تركيا، مع استشارات في رايسفايك بهولندا.',
    quickLinks: 'روابط سريعة',
    contactInfo: 'معلومات الاتصال',
    followUs: 'تابعنا',
    rights: 'جميع الحقوق محفوظة.',
  },
  treatments: {
    categories: {
      hairTransplant: 'تقنيات زراعة الشعر',
      facialHair: 'استعادة شعر الوجه',
      revision: 'المراجعة والتصحيح',
      nonSurgical: 'العلاجات غير الجراحية',
      additional: 'خدمات إضافية',
      guides: 'معلومات وأدلة'
    },
    bookConsultation: 'احجز استشارة مجانية',
    benefits: 'الفوائد',
    procedure: 'الإجراء',
    recovery: 'الجدول الزمني للتعافي',
    pricing: 'التسعير',
    faq: 'الأسئلة الشائعة',
    contraindications: 'موانع الاستعمال',
    beforeAfter: 'نتائج قبل وبعد',
    before: 'قبل',
    after: 'بعد',
    bookingSubtitle: 'حدد موعد استشارتك المجانية مع خبرائنا',
    preferredDate: 'التاريخ المفضل',
    selectDate: 'اختر تاريخًا',
    bookingMessage: 'أخبرنا عن مخاوفك بشأن الشعر وأي أسئلة لديك',
    submitBooking: 'إرسال طلب الحجز',
    bookingSuccess: 'شكرًا لك! سنتصل بك قريبًا لتأكيد موعدك.',
    category: 'فئات العلاج',
    all: 'جميع العلاجات',
    gallery: 'معرض قبل/بعد',
    resultsTitle: 'نتائجنا الحقيقية',
    resultsSubtitle: 'اكتشف قصص التحول لآلاف مرضانا السعداء',
    patientStories: 'قصص المرضى',
    viewDetails: 'عرض التفاصيل',
    grafts: 'طعوم',
    age: 'العمر',
    testimonial: 'شهادة المريض',
    allResults: 'جميع النتائج',
    filterByProcedure: 'تصفية حسب الإجراء'
  },
  comparison: {
    title: 'FUE مقابل DHI مقابل Sapphire FUE',
    subtitle: 'قارن بين تقنيات زراعة الشعر لإيجاد الطريقة المثالية لك',
    compareTitle: 'مقارنة التقنيات',
    method: 'الطريقة',
    duration: 'مدة الإجراء',
    recovery: 'وقت التعافي',
    scarring: 'الندوب',
    density: 'كثافة الشعر',
    pain: 'مستوى الألم',
    cost: 'نطاق التكلفة',
    bestFor: 'الأفضل لـ',
    fue: {
      name: 'FUE',
      duration: '6-8 ساعات',
      recovery: '7-10 أيام',
      scarring: 'نقاط صغيرة جدًا',
      density: 'عالية',
      pain: 'منخفض (تخدير موضعي)',
      cost: '€2,500 - €4,500',
      bestFor: 'المناطق الكبيرة، أقصى عدد من البصيلات'
    },
    dhi: {
      name: 'DHI',
      duration: '8-10 ساعات',
      recovery: '5-7 أيام',
      scarring: 'لا يوجد تقريبًا',
      density: 'عالية جدًا',
      pain: 'بسيط',
      cost: '€3,500 - €5,500',
      bestFor: 'العمل الدقيق، تصميم خط الشعر'
    },
    sapphire: {
      name: 'Sapphire FUE',
      duration: '6-8 ساعات',
      recovery: '5-7 أيام',
      scarring: 'بسيط',
      density: 'عالية جدًا',
      pain: 'منخفض',
      cost: '€3,000 - €5,000',
      bestFor: 'نتائج طبيعية، شفاء أسرع'
    },
    advantages: 'المزايا الرئيسية',
    disadvantages: 'الاعتبارات',
    faqTitle: 'الأسئلة الشائعة'
  },
  blog: {
    title: 'مدونة العناية بالشعر والصحة',
    subtitle: 'رؤى الخبراء ومعلومات العلاج وقصص نجاح المرضى',
    categories: {
      all: 'جميع المقالات',
      hairHealth: 'صحة الشعر',
      treatmentInfo: 'معلومات العلاج',
      patientStories: 'قصص المرضى',
      clinicGuides: 'دليل العيادات',
      procedures: 'الإجراءات'
    },
    readMore: 'اقرأ المقال كاملاً',
    backToBlog: 'العودة إلى المدونة',
    recentPosts: 'المقالات الأخيرة',
    relatedPosts: 'مقالات ذات صلة',
    publishedOn: 'نُشر في',
    by: 'بواسطة',
    views: 'مشاهدات',
    noPostsFound: 'لم يتم العثور على مقالات',
    searchPlaceholder: 'البحث عن مقالات...',
    admin: {
      title: 'إدارة المدونة',
      newPost: 'مقال جديد',
      editPost: 'تحرير المقال',
      deletePost: 'حذف المقال',
      published: 'منشور',
      draft: 'مسودة',
      title_label: 'العنوان',
      slug_label: 'رابط URL',
      category_label: 'التصنيف',
      excerpt_label: 'المقتطف',
      content_label: 'المحتوى',
      featuredImage_label: 'رابط الصورة المميزة',
      isPublished_label: 'نشر',
      save: 'حفظ المقال',
      cancel: 'إلغاء',
      deleteConfirm: 'هل أنت متأكد من حذف هذا المقال؟',
      viewOnSite: 'عرض على الموقع'
    }
  },
  error: "خطأ",
  success: "نجاح",
  admin: {
    dashboard: 'لوحة التحكم',
    overview: 'نظرة عامة والإدارة',
    whatsapp: 'واتساب',
    liveSupport: 'الدعم المباشر',
    leadManagement: 'إدارة العملاء المحتملين',
    blogManagement: 'إدارة المدونة',
    calendarView: 'عرض التقويم',
    gtmSetup: 'إعداد GTM',
    totalBookings: 'إجمالي الحجوزات',
    pending: 'قيد الانتظار',
    confirmed: 'مؤكد',
    cancelled: 'ملغى',
    patientResults: 'نتائج المرضى',
    published: 'منشور',
    thisMonth: 'هذا الشهر',
    newBookings: 'حجوزات جديدة',
    bookingTrend: 'اتجاه الحجوزات (آخر 6 أشهر)',
    monthlyStats: 'إحصائيات شهرية',
    bookingStatus: 'حالة الحجز',
    statusDistribution: 'التوزيع حسب الحالة',
    popularTreatments: 'العلاجات الشائعة',
    topTreatments: 'أكثر 5 علاجات طلباً',
    patientResultsManagement: 'إدارة نتائج المرضى',
    manageBeforeAfter: 'إدارة صور قبل/بعد والشهادات',
    addNewResult: 'إضافة نتيجة جديدة',
    editResult: 'تحرير نتيجة المريض',
    patientName: 'اسم المريض',
    age: 'العمر',
    procedureType: 'نوع الإجراء',
    graftsCount: 'عدد الطعوم',
    surgeryDate: 'تاريخ الجراحة',
    displayOrder: 'ترتيب العرض',
    beforeImage: 'صورة قبل',
    afterImage: 'صورة بعد',
    keepCurrentImage: 'اتركه فارغاً للاحتفاظ بالصورة الحالية',
    testimonial: 'شهادة',
    doctorNotes: 'ملاحظات الطبيب',
    publishImmediately: 'نشر فوراً',
    cancel: 'إلغاء',
    uploading: 'جاري الرفع...',
    update: 'تحديث',
    create: 'إنشاء',
    unpublish: 'إلغاء النشر',
    publish: 'نشر',
    draft: 'مسودة',
    surgery: 'الجراحة',
    order: 'الترتيب',
    noResults: 'لا توجد نتائج للمرضى حتى الآن. أضف الأولى!',
    deleteConfirm: 'هل أنت متأكد من حذف هذه النتيجة؟',
    leads: 'إدارة العملاء المحتملين',
    trackLeads: 'تتبع عملائك المحتملين',
    downloadCSV: 'تحميل CSV',
    totalLeads: 'إجمالي العملاء',
    hot: 'ساخن',
    warm: 'دافئ',
    cold: 'بارد',
    converted: 'محول',
    sourceReport: 'تقرير المصدر',
    conversions: 'تحويلات',
    searchPlaceholder: 'البحث بالبريد الإلكتروني أو الهاتف أو الاسم...',
    allStatuses: 'جميع الحالات',
    new: 'جديد',
    contacted: 'تم الاتصال',
    qualified: 'مؤهل',
    lost: 'مفقود',
    allSources: 'جميع المصادر',
    filterSource: 'تصفية حسب المصدر',
    leadList: 'قائمة العملاء',
    loading: 'جاري التحميل...',
    noLeads: 'لم يتم العثور على عملاء',
    contact: 'الاتصال',
    source: 'المصدر',
    score: 'النتيجة',
    activities: 'الأنشطة',
    status: 'الحالة',
    date: 'التاريخ',
    actions: 'الإجراءات',
    pageViews: 'مشاهدات الصفحة',
    formSubmissions: 'النماذج المرسلة',
    pdfDownloads: 'تحميلات PDF',
    chatInteractions: 'تفاعلات الدردشة',
    leadDetail: 'تفاصيل العميل',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    utmParams: 'معلمات UTM',
    notes: 'ملاحظات',
    saveNotes: 'حفظ الملاحظات',
    recentActivities: 'الأنشطة الأخيرة',
    delete: 'حذف',
    deleteLeadConfirm: 'هل أنت متأكد من حذف هذا العميل؟',
    initialEmail: 'بريد الاتصال الأول',
    followUpEmail: 'بريد المتابعة',
    call: 'اتصال',
    manualEmail: 'بريد يدوي',
    bookingsCalendar: 'تقويم الحجوزات',
    viewManageAppointments: 'عرض وإدارة جميع المواعيد',
    sendReminders: 'إرسال تذكيرات',
    searchByNameEmailPhone: 'البحث بالاسم أو البريد الإلكتروني أو الهاتف...',
    filterByStatus: 'تصفية حسب الحالة',
    allTreatments: 'جميع العلاجات',
    clearFilters: 'مسح الفلاتر',
    today: 'اليوم',
    more: 'المزيد',
    selectDate: 'اختر تاريخاً',
    noBookingsForDate: 'لا توجد حجوزات لهذا التاريخ',
    clickToView: 'انقر على تاريخ لعرض الحجوزات',
    reminded: 'تم التذكير',
    confirm: 'تأكيد',
    accessDenied: 'الوصول مرفوض',
    needAdminAccess: 'تحتاج إلى صلاحيات المسؤول للوصول إلى هذه الصفحة.',
    goHome: 'الرئيسية',
    galleryManagement: 'إدارة المعرض',
    backToGallery: 'العودة للمعرض',
    uploadNewPhoto: 'رفع صورة جديدة',
    title: 'العنوان',
    description: 'الوصف',
    altText: 'النص البديل (مهم للسيو)',
    treatmentPage: 'صفحة العلاج (اختياري)',
    selectTreatment: 'اختر علاج (يمكن تركه فارغاً)',
    treatmentNote: 'اختر علاج لعرض هذه الصورة في تلك الصفحة.',
    photo: 'صورة',
    upload: 'رفع',
    uploadedPhotos: 'الصور المرفوعة',
    removeFromPublish: 'إلغاء النشر',
    generalGallery: 'المعرض العام (بدون علاج)',
    emailTemplates: 'قوالب البريد',
    manageEmailTemplates: 'إدارة قوالب البريد التلقائي',
    newTemplate: 'قالب جديد',
    templateKey: 'المفتاح',
    active: 'نشط',
    preview: 'معاينة',
    edit: 'تحرير',
    editTemplate: 'تحرير القالب',
    templateName: 'اسم القالب',
    emailSubject: 'موضوع البريد',
    htmlContent: 'محتوى HTML',
    variablesNote: 'المتغيرات: {{name}}, {{email}} يمكن استخدامها',
    save: 'حفظ',
    close: 'إغلاق',
    createTemplate: 'إنشاء قالب',
    templateKeyUnique: 'مفتاح القالب (فريد)',
    cms: 'إدارة المحتوى',
    posts: 'المقالات',
    pages: 'الصفحات',
    media: 'الوسائط',
    categories: 'التصنيفات',
    settings: 'الإعدادات',
  },
  hairAnalysis: {
    title: "تحليل الشعر بالذكاء الاصطناعي",
    subtitle: "قم بتحميل صورتك للحصول على تقييم أولي مبني على الذكاء الاصطناعي. هذه أداة فرز أولية ولا تحل محل استشارة طبيب مؤهل.",
    uploadPhoto: "تحميل الصورة",
    uploadPhotoDesc: "قم بتحميل صورة واضحة لشعرك للتحليل",
    clickToUpload: "انقر لتحميل الصورة",
    analyzeNow: "تحليل الآن",
    analyzing: "جاري التحليل...",
    analysisResults: "نتائج التحليل",
    hairLossStage: "مرحلة فقدان الشعر",
    estimatedGrafts: "الطعوم المقدرة",
    recommendedTreatment: "العلاج الموصى به",
    recommendations: "التوصيات",
    detailedAnalysis: "التحليل التفصيلي",
    howItWorks: "كيف يعمل",
    step1: "قم بتحميل صورة واضحة للوجه من الأمام لشعرك",
    step2: "يقوم الذكاء الاصطناعي لدينا بتحليل كثافة شعرك ونمط الفقدان",
    step3: "احصل على تقييم فوري مع توصيات العلاج",
    step4: "احجز استشارة مع متخصصينا للتخطيط التفصيلي",
    priceEstimate: "السعر المقدر",
    pricePerGraft: "السعر لكل طعم",
    priceNote: "* سيتم تحديد السعر النهائي أثناء الاستشارة",
    priceRange: 'نطاق السعر المقدر',
    bookViaWhatsApp: 'احجز عبر واتساب',
    whatsappMessage: 'استشارة واتساب',
    getDetailedReport: 'احصل على تقرير PDF مفصل',
    reportDescription: 'احصل على تقرير تحليل شامل مع توصيات العلاج عبر البريد الإلكتروني',
    yourName: 'اسمك',
    yourEmail: 'بريدك الإلكتروني',
    enterName: 'أدخل اسمك',
    enterEmail: 'أدخل عنوان بريدك الإلكتروني',
    sendReport: 'إرسال التقرير إلى البريد الإلكتروني',
    sending: 'جاري الإرسال...',
    reportDisclaimer: 'تقرير PDF مفصل مجاني مع خطة العلاج والأسعار',
    shareResults: 'شارك نتائجك',
    shareDescription: 'شارك نتائج التحليل مع الأصدقاء والعائلة',
    shareNote: '* إنستجرام: سيتم نسخ النص إلى الحافظة',
  },
  auth: {
    seoTitle: 'تسجيل الدخول والتسجيل - بوابة المريض | Hair Art Clinics',
    seoDescription: 'الوصول إلى بوابة المرضى في Hair Art Clinics. سجّل الدخول لعرض السجلات الطبية وصور العلاج وإدارة المواعيد.',
    welcome: 'مرحبًا',
    welcomeSubtitle: 'سجّل الدخول للوصول إلى بوابة المريض أو أنشئ حسابًا جديدًا',
    forgotTitle: 'نسيت كلمة المرور',
    forgotSubtitle: 'أدخل بريدك الإلكتروني لاستلام رابط إعادة التعيين',
    resetTitle: 'إعادة تعيين كلمة المرور',
    resetSubtitle: 'أدخل كلمة المرور الجديدة',
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    newPassword: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    signIn: 'تسجيل الدخول',
    createAccount: 'إنشاء حساب',
    updatePassword: 'تحديث كلمة المرور',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    backToLogin: 'العودة إلى تسجيل الدخول',
    orContinueWith: 'أو تابع باستخدام',
    continueWithGoogle: 'المتابعة باستخدام Google',
    forgotYourPassword: 'هل نسيت كلمة المرور؟',
  },
  clinic: {
    city: 'لاهاي (Den Haag)',
    country: 'هولندا',
    region: 'جنوب هولندا',
    hoursLabel: 'ساعات العمل',
    hoursDaily: 'كل يوم',
  },
};
